import Hero from "./components/Hero/Hero";
import Step from "./components/Step/Step";
import Client from "./components/Client/Client";
import Subscribe from "./components/Subscribe/Subscribe";
import classes from "./Home.module.css";
import { motion } from "framer-motion";
import { useEffect } from "react";
import SectionLine from "../../components/Secton-line";

const Home = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.homeGrid}
    >
      <Hero className={classes.heroGrid} />
      <SectionLine className={classes.sectionLine} />
      <Step className={classes.stepGrid} />
      <SectionLine className={classes.sectionLine} />
      <Client className={classes.clientGrid} />
      <SectionLine className={classes.sectionLine} />
      <Subscribe className={classes.subsGrid} />
    </motion.div>
  );
};

export default Home;
